import fetch from "auth/FetchInterceptor";

/**
 * Dismissal de modais por usuário, server-side (one-time / por-versão / snooze).
 * Substitui o localStorage (que se perdia ao trocar de device). O back decide
 * o que mostrar.
 */
const preferenciaModalService = {};

// Lote: todos os modais que o usuário logado deve ver agora.
preferenciaModalService.getModaisParaExibir = async function () {
	return fetch({
		url: "/v1/rpc/modais",
		method: "get",
		headers: { "no-notification": true },
	});
};

// Registra o dismissal de um modal (idempotente no back).
preferenciaModalService.dispensarModal = async function (chave, versao, acao) {
	return fetch({
		url: "/v1/rpc/modais/dispensar",
		method: "post",
		data: { chave_modal: chave, versao, acao },
		headers: { "no-notification": true },
	});
};

export default preferenciaModalService;
